import React,{ useContext } from "react";
import "./Button.scss";
import { NavLink } from "react-router-dom";
import { DataContext } from "../../DataContext"; // Import the context
const Button = () => {
  const { data, loading } = useContext(DataContext);

  //const subAmount = data?.subscriptionAmount || 500;
  const updatedSubscriptionAmount = data?.updatedSubscriptionAmount || 500;
  const subDurationValue = data?.subscriptionDuration || 30;

  // Mapping durations to labels
  const durationMapping = {
    1: "DAY",
    3: "DAYS",
    7: "WEEK",
    15: "HALF MONTH",
    30: "MONTH",
    60: "2 MONTHS",
    90: "QUARTER",
    180: "HALF YEAR",
    365: "YEAR",
  };
  // Determine duration label
  //const subDuration = durationMapping[subDurationValue] || `${subDurationValue}${durationMapping[subDurationValue]}`;
  const subDuration = `${durationMapping[subDurationValue]}`;

  // Show loading state
  if (loading) {
    return <p>Loading...</p>;
  }

  // Render the button
  return (
    <section className="subscription-button">
      <NavLink to="/mybykrent">SUBSCRIBE AT ₹{updatedSubscriptionAmount}/{subDuration}</NavLink>
    </section>
  );
};

export default Button;